export default __webpack_public_path__ + "static/media/list-icon.f436033b.svg";